import { render } from "./TopicWorlds.vue?vue&type=template&id=fc0342da"
import script from "./TopicWorlds.vue?vue&type=script&lang=js"
export * from "./TopicWorlds.vue?vue&type=script&lang=js"

import "./TopicWorlds.vue?vue&type=style&index=0&id=fc0342da&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__